import React, { useEffect, useRef } from "react";
import video from "../assets/images/video2.mp4"
import YouTubeSubscribe from "../components/youtube-subscribe"
import logo from "../assets/images/md-logo.jpg"

const Banner = ({ channelData }) => {
  const videoEl = useRef(null);
  const attemptPlay = () => {
    videoEl &&
      videoEl.current &&
      videoEl.current.play().catch(error => {
        console.error("Error attempting to play", error);
      });
  };

  useEffect(() => {
    attemptPlay();
  }, []);

  return (
    <div className="banner-container">
      <video
        playsInline
        loop
        muted
        alt="All the devices"
        src={video}
        ref={videoEl}
        poster={logo}
        className="banner-video"
      />
      <div className="tag-des"><span className="tag-line">{channelData.tag}</span>{channelData.description}
      </div>
      <YouTubeSubscribe className="youtube-channel" />
      <p className="scrolldown">
        <a className="smoothscroll" href="#Video"><i className="icon-down-circle"></i></a>
      </p>
    </div>
  );
}
export default Banner;